import request from "../plugins/request";

// 上传文件
export const uploadFile = (file) => {
  return request({
    url: '/api/common/uploadFile',
    method: 'post',
    data: file
  })
}

// 获取公告列表
export const getNotifications = () => {
  return request({
    url: '/api/notice/getNotifications',
    method: 'get'
  })
}
